import { useState } from "react"
import { Divider, WizardFooter, WizardTitle } from "@components"
import { Radio, RadioGroup } from "@heroui/react"
import { PropTypes } from "prop-types"
import { UsersIcon } from "@heroicons/react/24/outline"

const Step1 = ({ filter, filters, handlePrevious, handleNext, isSubmitting }) => {
  const [selected, setSelected] = useState(filter)

  return (
    <div>
      <WizardTitle 
        title="Step 1 of 3 - Choose Recipients"
        description="Select a group of guardians to email. This can be refined in the next step."
        icon={<UsersIcon />}
      />
                
      <RadioGroup className="mb-4" value={selected} onValueChange={setSelected}>
        {filters.map((filterOption, index) => (
          <div key={filterOption.value}>
            <Radio value={filterOption.value} description={filterOption.description}>{filterOption.caption}</Radio>
            {index < filters.length-1 && <Divider className="mt-3" /> }
          </div>
        ))}
      </RadioGroup>

      <WizardFooter 
        currentStep={1} 
        totalSteps={3} 
        previousCaption="Cancel" 
        nextCaption="Filter Guardians" 
        handlePrevious={() => handlePrevious()} 
        handleNext={() => handleNext(selected)} 
        isSubmitting={isSubmitting}
      />
    </div>
  )
}

Step1.propTypes = {
  filter: PropTypes.string.isRequired,
  filters: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    caption: PropTypes.string.isRequired,
  })).isRequired,
  handlePrevious: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
}

export default Step1
